import Grid from "@mui/material/Grid2";
import { useContext } from "react";
import { SessionContext } from "../Contexts/SessionContext";
import BedroomsPerDwellingRange from "../TripRate/Filters/PrimaryFiltering/BedroomsPerDwellingRange";
import DaysOfWeek from "../TripRate/Filters/PrimaryFiltering/DaysOfWeek";
import ParamterRange from "../TripRate/Filters/PrimaryFiltering/ParameterRage";
import ParkingSpacesPerDwellingRange from "../TripRate/Filters/PrimaryFiltering/ParkingSpacesPerDwellingRange";
import ParkingSpacesRange from "../TripRate/Filters/PrimaryFiltering/ParkingSpacesRange";
import PercentageOfDwellingsRange from "../TripRate/Filters/PrimaryFiltering/PercentageOfDwellingsRange";
import TripRateParameters from "../TripRate/Filters/PrimaryFiltering/TripRateParameters";
import AdditionalInfo from "../Popups/AdditionalInfo";
import GFANotInUse from "../TripRate/Filters/PrimaryFiltering/GFANotInUse";

export default function ParameterFiltering() {
    const { sessionState } = useContext(SessionContext);

    const showExtraFilters = sessionState.tripRateMain === "03" && ["A", "B", "C", "D", "F", "K", "L", "M", "N", "O", "P"].includes(sessionState.tripRateSub);

    return (
        <Grid container size={12} alignItems="stretch">
            <Grid container size={4} alignContent={"flex-start"}>
                <TripRateParameters />
                <ParamterRange />
                <GFANotInUse />
            </Grid>
            <Grid container size={4} alignContent={"flex-start"}>
                <AdditionalInfo
                    colour="info"
                    icon="help"
                    buttonLabel="Note on external factors that influence trip
rates"
                    type="dialog"
                    dialogTitle="Note on external factors that influence trip
rates"
                    dialogContent="TRICS is very flexible in terms of the many filtering options that users can apply when putting together their scenario for trip rate calculations. However, it is important for users to note that there can be numerous factors external to the TRICS system that can also influence trip generation levels. Trip rate scatterplots can sometimes assist in indicating potential levels of influence these external factors may have, and sometimes also mask relationships between the selected trip rate calculation parameter and trip rates. Some examples of external influencing factors include local competition, road network issues, demographics, and economic situations. Levels of such influential factors may of course vary from site to site. It is very important to note that TRICS is designed to provide guidance on a range of potential trip generations and is not intended to provide an absolute prediction for any specific development scenario."
                />
                <DaysOfWeek />
            </Grid>
            <Grid container size={4} alignContent={"flex-start"}>
                <ParkingSpacesRange />
                {showExtraFilters && <ParkingSpacesPerDwellingRange />}
                {showExtraFilters && <BedroomsPerDwellingRange />}
                {showExtraFilters && <PercentageOfDwellingsRange />}
            </Grid>
        </Grid>
    );
}